import React from "react";
import { NavLink } from "react-router-dom";
import {
  footerLinks,
  sideBar1Links,
  sideBar2Links
  // sideBarLinks
} from "../utils/constants";
import { reactIcons } from "../utils/icons";
// import { toast } from "react-toastify";
// import { postAuthReq } from "../utils/apiHandlers";
// import Cookies from "js-cookie";

const PublicSidebar = ({ isOpen, setIsOpen, isVerify, getToken }) => {
  // const navigate = useNavigate();
  // const location = useLocation();
  // const [isLoading, setIsLoading] = useState(false);

  // const handleLogOut = async () => {
  //   if (isLoading) return;

  //   try {
  //     setIsLoading(true);

  //     const res = await postAuthReq("/auth/logout");
  //     const { data } = res;
  //     if (data.status === "success") {
  //       toast.success("Logged Out Successfully");
  //       Object.keys(Cookies.get()).forEach(function (cookie, attributes) {
  //         Cookies.remove(cookie, attributes);
  //       });
  //       navigate("/");
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (err) {
  //     toast.error(err.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <div className="portal-sidebar h-full flex flex-col justify-between overflow-hidden w-full pt-4">
      <div
        className={`pr-1 pl-[17px] flex ${
          !isOpen
            ? "justify-end transition-all duration-75"
            : "justify-start transition-all duration-75"
        }`}
      >
        <button
          onClick={() => {
            if (!isOpen) setIsOpen(true);
            else setIsOpen(false);
          }}
          className="w-9 h-9 flex-center text-white/70 hover:text-white rounded-lg border border-white/10 bg-white/[0.04] hover:bg-[#EE0000]/20 hover:border-[#EE0000]/50 text-2xl transition-colors hidden lg:flex"
        >
          {!isOpen ? reactIcons.arrowleft : reactIcons.arrowright}
        </button>
      </div>
      <div className="flex flex-col gap-1 mt-4 flex-1 px-3">
        {sideBar2Links.map((item, index) => {
          return (
            <NavLink
              key={index}
              to={item.path}
              end
              className={({ isActive }) =>
                `portal-nav-item ${isActive ? "is-active" : ""} ${isOpen ? "is-collapsed" : ""}`
              }
            >
              <span className="portal-nav-icon">{item.icon}</span>
              {!isOpen && (
                <span className="truncate">{item.title}</span>
              )}
            </NavLink>
          );
        })}

        {footerLinks.slice(0, 1).map((items, index) => {
          return (
            <NavLink
              to={items?.link}
              key={index}
              end
              className={`portal-nav-item lg:!hidden ${
                window?.location.pathname == items?.link ? "is-active" : ""
              }`}
            >
              <span className="portal-nav-icon">{items?.icon}</span>
              <span className="truncate">{items?.title}</span>
            </NavLink>
          );
        })}

        {sideBar1Links.map((item, index) => {
          return (
            <NavLink
              key={index}
              to={item.path}
              end
              className={({ isActive }) =>
                `portal-nav-item ${isActive ? "is-active" : ""} ${isOpen ? "is-collapsed" : ""}`
              }
            >
              <span className="portal-nav-icon">{item.icon}</span>
              {!isOpen && (
                <span className="truncate">{item.title}</span>
              )}
            </NavLink>
          );
        })}
        {footerLinks.slice(1).map((items, index) => {
          return (
            <NavLink
              to={items?.link}
              key={index}
              end
              className={`portal-nav-item lg:!hidden ${
                window?.location.pathname == items?.link ? "is-active" : ""
              }`}
            >
              <span className="portal-nav-icon">{items?.icon}</span>
              <span className="truncate">{items?.title}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default PublicSidebar;
